export default __webpack_public_path__ + "static/media/none-bg.684f6895.svg";